import { useDispatch } from 'react-redux'
import { UseQueryResult } from '@tanstack/react-query'
import RazonSocial from 'models/razonSocial'
import {
  selectActiveWorkspace,
  selectSelectedEmisor,
} from 'lib/helpers/selectors'
import useEmisoresList from 'hooks/queries/emisores'
import { useAppSelector } from 'store/hooks'
import { setSelectedEmisor } from 'actions/invoices'
import { IApiError } from 'services/Shared/shared.models'

interface IUseGetSelectedEmisor {
  emisor?: RazonSocial
  emisoresQuery: UseQueryResult<RazonSocial[], IApiError>
}

const useGetSelectedEmisor = (onError?: () => void): IUseGetSelectedEmisor => {
  const dispatch = useDispatch()

  const emisor = useAppSelector(selectSelectedEmisor)
  const workspaceId = useAppSelector(selectActiveWorkspace)

  const emisoresQuery = useEmisoresList(workspaceId, {
    noSave: true,
    onSuccess: rfcs => {
      if (!emisor) {
        rfcs.length > 0
          ? dispatch(setSelectedEmisor(rfcs[0]))
          : dispatch(setSelectedEmisor(undefined))
      }
    },
    onError: () => {
      onError && onError()
    },
  })

  return {
    emisor,
    emisoresQuery,
  }
}

export default useGetSelectedEmisor
